module.exports = __webpack_public_path__ + "static/media/opensea2.ba4f4eae.png";